import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED } from "@/i18n";
import { Languages } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { i18n: i18nInst, t } = useTranslation();
  const current = SUPPORTED.find((s) => s.code === i18nInst.language) || SUPPORTED[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="lang-switcher"
          aria-label={t("langSwitcher.label")}
          className="inline-flex items-center gap-1 h-11 md:h-10 px-3 rounded-full border-[3px] border-slate-900 bg-white text-slate-900 font-bold text-sm uppercase tracking-wider shadow-[0_3px_0_0_rgba(15,23,42,1)] hover:translate-y-[1px] hover:shadow-[0_2px_0_0_rgba(15,23,42,1)] active:translate-y-[2px] transition-all"
        >
          <Languages size={18} strokeWidth={3} />
          <span data-testid="lang-current">{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-[3px] border-slate-900 rounded-xl shadow-[0_4px_0_0_rgba(15,23,42,1)] bg-white p-1 min-w-[160px]">
        {SUPPORTED.map((s) => (
          <DropdownMenuItem
            key={s.code}
            data-testid={`lang-${s.code}`}
            onClick={() => i18nInst.changeLanguage(s.code)}
            className={
              "font-bold cursor-pointer rounded-lg px-3 py-2 text-sm " +
              (current.code === s.code ? "bg-yellow-200" : "")
            }
          >
            {s.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
